import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ConfigService } from './config.service';
import { getToken } from '@shared/utils/token-storage';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const config = inject(ConfigService);
  if (!req.url.startsWith(config.apiBaseUrl)) {
    return next(req);
  }

  let headers = req.headers.set('Authorization', `Bearer ${getToken() ?? ''}`);
  if (req.body instanceof FormData) {
    headers = headers.set('enctype', 'multipart/form-data');
  } else if (!req.headers.has('Content-Type')) {
    headers = headers.set('Content-Type', 'application/json');
  }

  return next(req.clone({ headers }));
};
